import type { Student } from '@/dto'
import { aiAxios, fetchSSE } from '@/utils/axios/aiAxios.ts'

const aiApi = {
  getSessionId: async () => {
    return await aiAxios.post<res.SessionId>('/ai/session')
  },

  // 유형분석 보고서 AI 코멘트 가져오기
  createAiComment(sessionId: string, studentId: Student['id'], data: req.CreateAiComment) {
    const body = JSON.stringify(data)

    return fetchSSE(`/ai/student-achievement/report-comment/${studentId}`, {
      params: { sessionId },
      body,
    })
  },

  // V2 보고서 AI 코멘트 생성
  createReportComment: async (data: req.CreateReportComment, signal?: AbortSignal) => {
    return await aiAxios.post<res.CreateReportComment>('/ai/report-comment', data, { signal })
  },
}

export default aiApi
